import { Box } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import PropTypes from 'prop-types';
import React from 'react';
import AllocationDropDownRenderer from './AllocationDropDownRenderer';

const propTypes = {
  userProjectAllocationData: PropTypes.array.isRequired,
  userId: PropTypes.number.isRequired,
  userProjectSkillDetails: PropTypes.func.isRequired,
};

const UserProjects = ({ userProjectAllocationData, userProjectSkillDetails, userId }) => {
  const columnDefs = [
    {
      headerName: 'Project Name',
      field: 'projectName',
    },
    {
      headerName: 'Role',
      field: 'skillName',
    },
    {
      headerName: 'Allocation Capacity',
      field: 'allocationPercent',
      cellRenderer: AllocationDropDownRenderer,
      cellRendererParams: {
        userId,
        userProjectSkillDetails,
      },
    },
    {
      headerName: 'Allocation Date',
      field: 'projectDuration',
    },
  ];
  return (
    <div className="user-panel">
      <div className="time-add-block">
        <span className="user-detail-title">Project Allocation</span>
      </div>

      <Box className="container">
        {userProjectAllocationData?.length > 0 ? (
          <div className="container">
            <Box className="ag-theme-alpine">
              <AgGridReact
                className="cell-click common-table-grid"
                gridOptions={{
                  suppressNoRowsOverlay: true,
                  rowHeight: 40,
                  headerHeight: 40,
                  defaultColDef: {
                    resizable: true,
                  },
                }}
                rowBuffer
                sizeColumnsToFit
                rowData={userProjectAllocationData}
                columnDefs={columnDefs}
                domLayout="autoHeight"
                animateRows
                debounceVerticalScrollbar
              />
            </Box>
          </div>
        ) : (
          <Box className="text-center">No Project Allocated</Box>
        )}
      </Box>
    </div>
  );
};
UserProjects.propTypes = propTypes;
export default UserProjects;
